<template>
  <Modal nome="criarIntegracao">
    <div class="gateways">
      <button @click="escolherTipo('hotmart')" :class="{ ativo: state.gateway === 'hotmart' }">
        <Svgs nome="logo-hotmart" />
      </button>
      <button @click="escolherTipo('kiwify')" :class="{ ativo: state.gateway === 'kiwify' }">
        <Svgs nome="logo-kiwify" />
      </button>
      <button @click="escolherTipo('ticto')" :class="{ ativo: state.gateway === 'ticto' }">
        <Svgs nome="logo-ticto" />
      </button>
    </div>

    <Campo tipo="text" placeholder="Ex: High Ticket" completar="false" label="Nome da integração" v-model="state.nome" />
    <Campo tipo="tel" placeholder="0" completar="false" mascara="####" label="Pontuação ao comprar" v-model="state.pontuacao" />

    <div class="cursos">
      <h3>Seleciona os cursos que o aluno receberá acesso após a compra</h3>
      <Checklist :dados="state.cursos" />
    </div>

    <BotaoPrincipal nome="Criar integração" :disabled="state.loading" @click="criarIntegracao" />
  </Modal>
</template>

<script setup>
import { inject, reactive, onMounted, computed, watch } from 'vue'
import { useStoreModal, useStoreAreas, useStoreIntegracoes, useStoreCursos } from '@stores'

import Checklist from '@components/global/elementos/Checklist.vue'
import BotaoPrincipal from '@components/global/elementos/BotaoPrincipal.vue'
import Campo from '@components/global/elementos/Campo.vue'
import Modal from '@components/global/modal/Modal.vue'
import Svgs from '@svgs'

const emitter = inject('emitter')
const storeAreas = useStoreAreas()
const storeIntegracoes = useStoreIntegracoes()
const storeCursos = useStoreCursos()
const storeModal = useStoreModal()
const dadosModal = computed(() => storeModal.dadosDoModal('criarIntegracao'))

const state = reactive({
  cursos: [],
  nome: '',
  gateway: 'hotmart',
  pontuacao: '',
  loading: false
})

async function carregarTodosOsCursos() {
  const idArea = storeAreas.area?._id
  if (!idArea) return

  await storeCursos.receberTodos(idArea)

  if (storeCursos.cursos?.length > 0) {
    state.cursos = storeCursos.cursos.map((curso) => ({
      nome: curso.nome,
      id: curso._id,
      selecionado: false
    }))
  } else {
    state.cursos = []
  }
}

function escolherTipo(gateway) {
  state.gateway = gateway
}

async function carregarCampos() {
  state.gateway = dadosModal.value?.id
  await carregarTodosOsCursos()
}

function limparCampos() {
  state.nome = ''
  state.gateway = 'hotmart'
  state.pontuacao = ''
  state.cursos = []
  state.loading = false
}

async function criarIntegracao() {
  if (!validarDados()) return

  state.loading = true

  const idArea = storeAreas.area?._id

  const payload = {
    idsCursos: state.cursos.filter((curso) => curso.selecionado).map((curso) => curso.id),
    nome: state.nome,
    gateway: state.gateway,
    numeroPontosAoComprar: state.pontuacao,
    ativo: true
  }

  const adicionadoOk = await storeIntegracoes.adicionar(idArea, payload)
  if (adicionadoOk !== true) return

  emitter.emit('atualizarIntegracoes')

  await storeIntegracoes.receberTodos(idArea)

  const ultimaIntegracao = storeIntegracoes.integracoes.sort((a, b) => new Date(b.dataCriacao) - new Date(a.dataCriacao))[0]
  const idIntegracao = ultimaIntegracao._id

  storeModal.fecharModal('criarIntegracao')
  storeModal.abrirModalEdicao('editarWebhook', 'integracao', `Webhook para ${payload.gateway}`, idIntegracao)
  limparCampos()
}

function validarDados() {
  let mensagem
  if (!state.nome || !state.gateway || !state.pontuacao || !state.cursos) mensagem = 'Preencha todos os campos obrigatórios'
  else return true

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: mensagem })
  return false
}

watch(
  dadosModal,
  (novoValor) => {
    if (novoValor) {
      carregarCampos()
    }
  },
  { immediate: true }
)

onMounted(() => {
  emitter.on('limparCampos', limparCampos)
})
</script>

<style scoped>
.campo {
  margin: 0 0 15px 0;
}
.gateways {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 15px 0;
}
.gateways button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(33.33% - 5px);
  height: 50px;
  background-color: var(--cor-escuro-2);
  border: 1px solid var(--cor-escuro-2);
  border-radius: 10px;
  transition: all 0.3s;
}
.gateways button svg {
  width: 70px;
  max-height: 20px;
  fill: var(--cor-branco);
  transition: all 0.3s;
}
.gateways button.ativo {
  border: 1px solid var(--cor-marca);
}
.gateways button.ativo svg {
  fill: var(--cor-marca);
}
.cursos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  border-radius: 10px;
  border: 1px dashed var(--cor-escuro-3);
  width: 100%;
}
.cursos h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-5);
  margin: 0 0 10px 0;
}
</style>
